import { render, staticRenderFns } from "./ModalIframe.vue?vue&type=template&id=796660e4&scoped=true&"
import script from "./ModalIframe.vue?vue&type=script&lang=js&"
export * from "./ModalIframe.vue?vue&type=script&lang=js&"
import style0 from "./ModalIframe.vue?vue&type=style&index=0&id=796660e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796660e4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loading: require('/home/circleci/repo/components/Loading.vue').default})
